module.exports = __webpack_public_path__ + "img/icon_dxy.01ca2e88.png";